'use client';

import { useMemo } from 'react';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg';

export function Avatar({
  name,
  src,
  size = 'md',
  color = '#0ea5e9',
  speaking,
  status,
  className,
  style,
}: {
  name?: string;
  src?: string;
  size?: AvatarSize;
  color?: string;
  /** ring "sedang bicara" */
  speaking?: boolean;
  /** warna dot status (mis. var(--mx-success)) */
  status?: string;
  className?: string;
  /** override ukuran/warna (mis. placeholder besar) — di-merge dengan style internal */
  style?: React.CSSProperties;
}) {
  const initials = useMemo(
    () => (name ? name.split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase() : ''),
    [name],
  );
  const cls = ['mx-avatar', size !== 'md' && `mx-avatar--${size}`, speaking && 'mx-avatar--speaking', className]
    .filter(Boolean)
    .join(' ');
  return (
    <span
      className={cls}
      role={name ? 'img' : undefined}
      aria-label={name}
      style={{ ...(src ? { background: `center / cover no-repeat url(${src})` } : { background: color }), ...style }}
    >
      {!src && initials}
      {status && <span className="mx-avatar__status" style={{ background: status }} />}
    </span>
  );
}
